export enum RiderVerificationCheckEnum {
    None = 0,
    DriverLicenseIsTheDriversLicenseLegibleAndEasilyReadable = 1,
    DriverLicenseIsTheDriversLicenseCurrentValid = 2,
    DriverLicenseIsTheDriversLicenseClassifiedAsProfessionalLicense = 3,
    DriverLicenseIsTheApplicantAgeBetween18And65YearsOld = 4,

    PersonalDetailName = 5,
    PersonalDetailDateOfBirth = 6,
    PersonalDetailGender = 7,
    PersonalDetailExpiryDate = 8,

    NBIClearanceName = 9,
    NBIClearanceDateOfBirth = 10,
    NBIClearanceGender = 11,
    NBIClearanceIssuedWithinLast6Months = 12,
    NBIClearanceApplicantHasClearRecord = 13,
    NBIClearanceDoesThePhotoInTheDriverLiceseMatchThePhotoInTheNBIClearance = 14,

    VaccineCardName = 15,
    VaccineCardDateOfBirth = 16,
    VaccineCardHasHadAtLeast2VaccinesShots = 17,
    VaccineCardWhatWasTheDateOfTheLastShot = 18,

    /////Vehicles
    VehicleDetailsAreTheUploadedImagesCorrectAndAccurate = 19,
    VehicleOfficialReceiptIsTheDocumentLegibleAndEasilyReadable = 20,
    VehicleOfficialReceiptIsThePlateNumberMatch = 21,
    VehicleOfficialReceiptIsTheVehicleMakeAndModelMatch = 22,
    VehicleOfficialReceiptIsTheYearOfManufactureMatch = 23,
    VehicleOfficialReceiptIsTheDocumentConsideredOfficial = 24,
    VehicleCertificateRegistrationIsTheDocumentLegibleAndEasilyReadable = 25,
    VehicleCertificateRegistrationIsThePlateNumberMatch = 26,
    VehicleCertificateRegistrationIsTheVehicleMakeAndModelMatch = 27,
    VehicleCertificateRegistrationIsTheYearOfManufactureMatch = 28,
    VehicleSPAorALIsTheDocumentLegibleAndEasilyReadable = 29,
    VehicleSPAorALDoesTheDocumentMatchToTheNameOfTheOwner = 30,
    VehicleSPAorALHasTheDocumentBeenSignedAndSealedByAnAttorney = 31,
    VehicleSPAorALDoesTheDocumentAlignWithTheNameOfTheDriver = 32,
    VehicleSPAorALIsThereAnIdentificationBelongingToTheDocument = 33,
    VehicleSPAorALAreThereThreeSpecimenSignaturesIncludedInTheDocument = 34,
    VehiclePaCpcTasIsTheDocumentValidAndUpToDate = 35,
    VehiclePaCpcTasIsTheDocumentLegibleAndEasilyReadable = 36,
    VehiclePaCpcTasDoesTheDriverNameCorrespondWithTheProvidedInformation = 37,
    VehiclePaCpcTasIsThePlateNumberMatch = 38,
    VehiclePaCpcTasHasTheTnvsTasDocumentBeenSigned = 39,
    VehiclePaCpcTasDoesTheTnvsTasOrNumberMatch = 40,
    VehiclePamiScciDoesThePamiScciInsuranceMeetTheRequirementsOfAdequacy = 41,
    VehiclePamiScciDoesThePamiScciInsuranceCoverTheCommercialUseOfTheVehicle = 42,
    VehiclePamiScciIsThePamiScciInsuranceUpToDate = 43,
    VehiclePamiScciDoesThePamiScciInsuranceMatchTheDriverName = 44,
    VehiclePamiScciDoesThePamiScciInsuranceMatchThePlateNumber = 45,
    VehiclePamiScciDoesThePamiScciInsuranceHaveSignature = 46,
    VehiclePamiScciIsThePamiScciDocumentClearAndEasilyReadable = 47,
    VehicleComprehensiveInsuranceDoesTheComprehensiveInsuranceMeetTheRequirementsOfAdequacy = 48,
    VehicleComprehensiveInsuranceIsTheComprehensiveInsuranceUpToDate = 49,
    VehicleComprehensiveInsuranceDoesTheComprehensiveInsuranceMatchTheDriverName = 50,
    VehicleComprehensiveInsuranceDoesTheComprehensiveInsuranceMatchThePlateNumber = 51,
    VehicleComprehensiveInsuranceDoesTheComprehensiveInsuranceHaveSignature = 52,
    VehicleComprehensiveInsuranceIsTheComprehensiveInsuranceClearAndEasilyReadable = 53,

    //////Application Form
    ApplicationFormIsTheDocumentLegibleAndEasilyReadable = 54,
    ApplicationFormIsThePlateNumberMatch = 55,
    ApplicationFormIsTheVehicleMakeAndModelMatch = 56,
    ApplicationFormIsTheYearOfManufactureMatch = 57,
    ApplicationFormIsTheMotorAndChassisNumberMatch = 58,
    ApplicationFormIsTheEmailAddressAndPhoneNumberMatch = 59,

    //////Proof Nationality
    ProofNationalityIsTheDocumentLegibleAndEasilyReadable = 60,
    ProofNationalityIsTheNameMatch = 61,
    ProofNationalityIsTheDateOfBirthMatch = 62,
    ProofNationalityIsTheSexMatch = 63,
    ProofNationalityIsTheAddressMatch = 64,
    ProofNationalityDoesTheApplicantHoldFilipinoCitizenship = 65,
    ProofNationalityCanYouConfirmThatTheRequirementIsPhotocopyOfAnAuthenticDocument = 66,

    NBIClearanceExpiryAt = 67,
    VaccineCardWhatWasTheDateOfLastShot = 68,

    /////Vehicles
    VehicleDetailsVehicleOwnershipMismatch = 69,
    VehicleDetailsPlateNumberMismatch = 70,
    VehicleDetailsVehicleMakeMismatch = 71,
    VehicleDetailsVehicleModelMismatch = 72,
    VehicleDetailsBuildYearMismatch = 73,
    VehicleDetailsColorMismatch = 74,

    //Medical Certificate
    MedicalCertificationIsTheMedcertCurrentlyValid = 75
}
